module.exports = __webpack_public_path__ + "static/award-29d46f3a1a8e5d30d2d51888c705ac37.jpg";